export const LOOKER_ORIGIN = "https://hyro.cloud.looker.com";
export const MESSAGE_TYPES = {
  DASHBOARD_LOADED: "dashboard:loaded",
  DASHBOARD_FILTERS_CHANGED: "dashboard:filters:changed",
  DASHBOARD_FILTERS_UPDATE: "dashboard:filters:update",
  DASHBOARD_RUN: "dashboard:run"
};
